module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý saler"
    }
  }, [_c('router-link', {
    staticClass: "ui mini violet button",
    attrs: {
      "to": {
        name: 'saller-config'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Cấu hình chung")]), _vm._v(" "), _c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'new-user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.salerTable,
    attrs: {
      "table-name": _vm.salerTable,
      "data-source": "saller-salary",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.salerTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.salerTable].current_page - 1) * _vm.dataPaginations[_vm.salerTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Saller",
            "width": "250"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.saler) ? _c('div', [(scope.row.saler.data.name) ? _c('p', [_c('i', {
                staticClass: "fa fa-user",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.name))])]) : _vm._e(), _vm._v(" "), (scope.row.saler.data.phone) ? _c('p', [_c('i', {
                staticClass: "fa fa-phone",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.saler.data.email) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.saler.data.email))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('i', {
                staticClass: "fa fa-calendar"
              }), _vm._v(" " + _vm._s(scope.row.month))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn giá"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Đơn DS: "), _c('small', {
                staticClass: "pull-right text-red",
                staticStyle: {
                  "font-size": "10px"
                }
              }, [_vm._v(_vm._s(_vm.commissionText(scope.row.config_salary.kpi)))])]), _vm._v(" "), _c('p', [_vm._v("Đơn TL: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.config_salary.salary_accumulation)))])]), _vm._v(" "), _c('p', [_vm._v("Khách mới: "), _c('span', {
                staticClass: "pull-right text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.config_salary.salary_by_customer)))])]), _vm._v(" "), _c('p', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn & Khách",
            "width": "130"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Đơn DS: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_new_shipment)))])]), _vm._v(" "), _c('p', [_vm._v("Đơn TL: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_accumulation_shipment)))])]), _vm._v(" "), _c('p', [_vm._v("Khách: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.total_new_customer)))])]), _vm._v(" "), _c('p', [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Lương",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Lương DS: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_commission)))])]), _vm._v(" "), _c('p', [_vm._v("Lương TL: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_accumulation)))])]), _vm._v(" "), _c('p', [_vm._v("Thưởng khách: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary_new_customer)))])]), _vm._v(" "), _c('p', [_vm._v("Thưởng chỉ tiêu: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.bonus)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng lương: "), _c('span', {
                staticClass: "text-red pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.salary)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "KPI",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(" KPI: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.kpi)))])]), _vm._v(" "), _c('p', [_vm._v(" % KPI: "), _c('span', {
                staticClass: "pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.kpi_percent)))])]), _vm._v(" "), _c('p', {
                staticClass: "text-right"
              }, [_c('span', {
                class: _vm.statusColor[scope.row.kpi_status]
              }, [_vm._v(_vm._s(scope.row.kpi_status_txt))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "55"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(scope.row.saler) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cấu hình lương"
                }
              }, [_c('router-link', {
                staticClass: "text-violet padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'saller-config-by-saler',
                    params: {
                      id: scope.row.saler.data.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-cog"
              })])], 1) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn saler"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.sale_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sale_id", $$v)
      },
      expression: "filters.sale_id"
    }
  }, _vm._l((_vm.administrators), function(admin) {
    return _c('el-option', {
      key: admin.id,
      attrs: {
        "label": admin.name,
        "value": admin.id
      }
    })
  }), 1)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa08835"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/saler/Saler.vue
// module id = 628
// module chunks = 1